module.exports = "<symbol id=\"tt-icon-info\" viewBox=\"0 0 24 24\"><path d=\"M12 .25A11.75 11.75 0 1 0 23.75 12 11.76 11.76 0 0 0 12 .25zm0 21.15a9.4 9.4 0 1 1 9.4-9.4 9.41 9.41 0 0 1-9.4 9.4z\" xmlns=\"http://www.w3.org/2000/svg\"/><path d=\"M13.18 15.53v-4.7A1.17 1.17 0 0 0 12 9.65H9.65V12h1.17v3.53H8.48v2.35h7.05v-2.35z\"/><circle cx=\"12\" cy=\"7.3\" r=\"1.47\"/></symbol>"


//////////////////
// WEBPACK FOOTER
// ./src/build/KmHgiPlfcrGbDfYsite/assets/svg/pdp-page/info.svg
// module id = 207
// module chunks = 9